import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.textBackground.light,
    marginBottom: theme.spacing(12),
    padding: theme.spacing(4),
  },
  salesforceWrapper: {
    padding: `${theme.spacing(0, 1)} !important`,
  },
  footerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
  },
  customFooter: {
    height: theme.spacing(8),
    padding: theme.spacing(1.5, 5),
  },
  container: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  formWidth: { width: '100%' },
  activityLogWidth: { width: '30%' },
  hideActivityLog: {
    display: 'block',
  },
  textHead: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.shadows.light,
  },
  textSub: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    color: theme.palette.poweredBy.main,
  },
  productWrapper: {
    backgroundColor: theme.palette.text.white,
    borderRadius: theme.spacing(1),
    padding: '16px 40px',
    marginBottom: theme.spacing(3),
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  externalFooter: {
    margin: `${theme.spacing(0, -2.5)} !important`,
  },
}))
